import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteWorkout(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteWorkout = (workoutId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`workouts/${workoutId}/`);
  };

  return useMutation(deleteWorkout, {
    onSuccess: (_, workoutId) => {
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'workouts' && query.queryKey[1] !== workoutId,
      });
    },
  });
}
